"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CfgCountryListEn_1 = require("./CfgCountryListEn");
var CfgCountryListRu_1 = require("./CfgCountryListRu");
var CfgCountryListLangFactory = /** @class */ (function () {
    function CfgCountryListLangFactory() {
    }
    CfgCountryListLangFactory.getRU = function () {
        return;
    };
    CfgCountryListLangFactory.getLangInstance = function (Lang) {
        if (Lang == "RU") {
            return CfgCountryListRu_1.CfgCountryListRu.getLangData();
        }
        return CfgCountryListEn_1.CfgCountryListEn.getLangData();
    };
    return CfgCountryListLangFactory;
}());
exports.CfgCountryListLangFactory = CfgCountryListLangFactory;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_country/ui/lang/CfgCountryListBase.ts
// module id = 2054
// module chunks = 0